import PageOnboarding from "./PageOnboarding";
export default PageOnboarding;
